import { render, staticRenderFns } from "./NuevoAdministrador.vue?vue&type=template&id=2cd741ad&"
import script from "./NuevoAdministrador.vue?vue&type=script&lang=js&"
export * from "./NuevoAdministrador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports